import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
/*import Service from '../../components/Service';*/
import AboutS2 from '../../components/AboutS2';
import TeamProfiles from '../../components/TeamProfiles';
/*import FunFact from '../../components/FunFact';*/
import PartnerSection from '../../components/PartnerSection';


const AboutPage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <PageTitle pageTitle={'Sobre Nosotros'} pagesub={'Nosotros'}/> 
           { /*<Service Fclass={'wpo-features-section-s2'}/>*/}
            <AboutS2/>
            { /*<FunFact/>*/}
            <TeamProfiles/>
            <PartnerSection tNone={'title-none'}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default AboutPage;
